import { render, staticRenderFns } from "./VerdictCards.vue?vue&type=template&id=17c7db22&"
import script from "./VerdictCards.vue?vue&type=script&lang=js&"
export * from "./VerdictCards.vue?vue&type=script&lang=js&"
import style0 from "./VerdictCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports